import { type IconSystem, icons } from '@opallabs/constellation'
import { kuiperClassNames } from '../utils/kuiperClassNames'

import './styles.scss'

export interface Props {
  ariaLabel?: string
  ariaMode?: 'visible' | 'presentational' | 'hidden'
  className?: string
  color?: string
  colorCode?: string
  system?: IconSystem
  height?: number | string
  width?: number | string
  glyph?: string
  style?: React.CSSProperties
}

interface AriaAnnotation {
  'aria-hidden'?: boolean
  'aria-label'?: string
  role?: string
}

const Icon: React.FC<Props> = ({
  ariaLabel,
  ariaMode = 'visible',
  className,
  color = '',
  colorCode = '',
  glyph = '',
  height = 16,
  style,
  system = 'hypernova',
  width = 16,
}) => {
  const SVG = icons[system][glyph]

  // if the icon isn't found, you may be requesting the wrong glyph.
  if (!SVG) {
    return null
  }

  const ariaAnnotation: AriaAnnotation = {
    role: 'img',
  }
  if (ariaMode === 'hidden') {
    ariaAnnotation['aria-hidden'] = true
  } else if (ariaMode === 'presentational') {
    ariaAnnotation.role = 'presentation'
  }
  if (ariaLabel) {
    ariaAnnotation['aria-label'] = ariaLabel
  }

  return (
    <div
      draggable={false}
      className={kuiperClassNames('icon-wrapper', className, color)}
      style={{ color: `#${colorCode}`, fill: `#${colorCode}` }}
    >
      <SVG
        className={kuiperClassNames(`icon icon-${glyph}`)}
        height={height}
        style={style}
        width={width}
        {...ariaAnnotation}
      />
      <div className={kuiperClassNames('icon-cover')} />
    </div>
  )
}

export default Icon
